import { useEffect } from "react";
import { DotButton, useDotButton } from "./DotButton";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from "./ArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import cn from "classnames";

const EmblaCarousel = ({ children, options = {loop: true}, autoplayReady = false, titles, colors }) => {
  //
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay({playOnInit: false, delay: 5000})]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi);

  useEffect(() => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;
    if (autoplayReady && !autoplay.isPlaying()) {
      autoplay.play();
    }
  }, [autoplayReady, emblaApi]);

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {children}
        </div>
      </div>

      {typeof emblaApi !== "undefined" && <div className="embla__controls" style={colors ? {color: colors[selectedIndex]} : {}}>
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>

        <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={cn("embla__dot", {"active": index === selectedIndex})}
            />
          ))}
        </div>

        {titles && <button className="next-title" onClick={onNextButtonClick} disabled={nextBtnDisabled}>
          Next: {titles[selectedIndex + 1 >= scrollSnaps.length ? 0 : selectedIndex + 1]}
        </button>}
      </div>}
    </section>
  )
}

export default EmblaCarousel
